<div>
  <div class="d-flex justify-content-between mb-3">
    <div class="d-flex">
      <div>
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" class="mr-1" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M2.5 10C2.27778 9.73333 2.09178 9.44733 1.942 9.142C1.79222 8.83667 1.66711 8.51711 1.56667 8.18333C1.51111 8.00556 1.53333 7.84733 1.63333 7.70867C1.73333 7.57 1.87778 7.48378 2.06667 7.45C2.25556 7.41622 2.42511 7.44956 2.57533 7.55C2.72556 7.65044 2.82822 7.78933 2.88333 7.96667C2.93844 8.144 3.008 8.31356 3.092 8.47533C3.176 8.63711 3.27311 8.79533 3.38333 8.95C3.49356 9.10467 3.61022 9.24644 3.73333 9.37533C3.85644 9.50422 3.98978 9.62911 4.13333 9.75C4.27689 9.87089 4.36867 10.0209 4.40867 10.2C4.44867 10.3791 4.42356 10.5458 4.33333 10.7C4.24311 10.8542 4.10978 10.9571 3.93333 11.0087C3.75689 11.0602 3.59578 11.0296 3.45 10.9167C3.27222 10.7833 3.10289 10.6389 2.942 10.4833C2.78111 10.3278 2.63378 10.1667 2.5 10ZM7 13.3333C6.72222 13.3333 6.48622 13.2362 6.292 13.042C6.09778 12.8478 6.00044 12.6116 6 12.3333V8.33333C6 8.05556 6.09733 7.81956 6.292 7.62533C6.48667 7.43111 6.72267 7.33378 7 7.33333H8.46667C8.63333 7.33333 8.79178 7.37222 8.942 7.45C9.09222 7.52778 9.21156 7.63889 9.3 7.78333L9.66667 8.33333H12.3333C12.6111 8.33333 12.8473 8.43067 13.042 8.62533C13.2367 8.82 13.3338 9.056 13.3333 9.33333V12.3333C13.3333 12.6111 13.2362 12.8473 13.042 13.042C12.8478 13.2367 12.6116 13.3338 12.3333 13.3333H7ZM1 6C0.722222 6 0.486222 5.90289 0.292 5.70867C0.0977777 5.51444 0.000444444 5.27822 0 5V1C0 0.722222 0.0973333 0.486222 0.292 0.292C0.486667 0.0977777 0.722667 0.000444444 1 0H2.46667C2.63333 0 2.79178 0.0388889 2.942 0.116667C3.09222 0.194444 3.21156 0.305556 3.3 0.45L3.66667 1H6.33333C6.61111 1 6.84733 1.09733 7.042 1.292C7.23667 1.48667 7.33378 1.72267 7.33333 2V5C7.33333 5.27778 7.23622 5.514 7.042 5.70867C6.84778 5.90333 6.61156 6.00044 6.33333 6H1ZM10.1333 4.66667C10.0111 4.45556 9.87222 4.26111 9.71667 4.08333C9.56111 3.90556 9.38889 3.73889 9.2 3.58333C9.05556 3.46111 8.964 3.31111 8.92533 3.13333C8.88667 2.95556 8.91156 2.78889 9 2.63333C9.08844 2.47778 9.22178 2.37511 9.4 2.32533C9.57822 2.27556 9.73933 2.306 9.88333 2.41667C10.1167 2.59444 10.3333 2.78889 10.5333 3C10.7333 3.21111 10.9167 3.43889 11.0833 3.68333C11.3167 4.02778 11.5084 4.39733 11.6587 4.792C11.8089 5.18667 11.9116 5.59489 11.9667 6.01667C11.9889 6.19444 11.9362 6.34733 11.8087 6.47533C11.6811 6.60333 11.5227 6.66711 11.3333 6.66667C11.144 6.66622 10.9858 6.60511 10.8587 6.48333C10.7316 6.36156 10.6509 6.206 10.6167 6.01667C10.5722 5.77222 10.5111 5.53889 10.4333 5.31667C10.3556 5.09444 10.2556 4.87778 10.1333 4.66667Z"
              fill="#969696" />
          </svg>
        </span>
        @if(searchType == 'similar-candidate-from-linkedinurl' || searchType == 'similar-candidate-resume-upload' || similarityInsightsData) {
 <span class="f-12 font-weight-600 text-black">
                Similarity Insights
        </span>
        } @else {

           <span class="f-12 font-weight-600 text-black">
          AI Profile Review
        </span>
      }

      </div>
      @if (criteriaCount > 0 && !showEmptyState || (calledfromData === 'Project' || (calledfromData === 'pipeline-list' && (showExplanationLoader || roleFitTableData?.length > 0)) )) {
      <div class="dropdown ml-3 add-to" >
        <button data-testid="auto-app-hire-slider-ai-insights-view-button-1" class="btn-trms-gray selecttableviewBtn dropdown-toggle" type="button" id="tableviewbtn"
          appDropdownToggle data-bs-toggle="dropdown" aria-expanded="false">
          {{ viewMode === 'table' ? 'Table View' : 'Detail View' }}
        </button>
        <ul class="dropdown-menu" aria-labelledby="tableviewbtn">
          <li><a data-testid="auto-app-hire-slider-ai-insights-view-a-1" class="dropdown-item" (click)="setViewMode('table')">Table View</a></li>
          <li><a data-testid="auto-app-hire-slider-ai-insights-view-a-2" class="dropdown-item" (click)="setViewMode('detail')">Detail View</a></li>
        </ul>
      </div>
    }
    </div>
    @if (criteriaCount > 0 || calledfromData === 'Project') {
    <div>
          @if(candidate?.personSearchScore?.category === 'EXCELLENT' || candidate?.screening_response?.matchcategory === 'EXCELLENT') {
    <div class="criteria-label excellent-match">
      Excellent Match
    </div>
    } @if(candidate?.personSearchScore?.category === 'POTENTIAL' || candidate?.screening_response?.matchcategory === 'POTENTIAL') {
    <div class="criteria-label potential-fit flex-shrink-0 ms-2">
      Potential Fit
    </div>
    }
    @if(candidate?.personSearchScore?.category === 'NOT_A_MATCH' || candidate?.screening_response?.matchcategory === 'NOT_A_MATCH') {
    <div class="criteria-label not-fit flex-shrink-0 ms-2">
      Not a Fit
    </div>
    }
        @if(candidate?.personSearchScore?.category === 'GOOD' ||  candidate?.screening_response?.matchcategory === 'GOOD') {
    <div class="criteria-label good-fit flex-shrink-0 ms-2">
      Good Fit
    </div>
    }
    </div>
  }

  </div>
  <!-- Description without criteria -->
   @if(calledfromData != 'Project' && calledfromData != 'Recommend-list' && !showLongSummaryLoader && searchType != 'job-description' && searchType != 'similar-candidate-from-linkedinurl' && searchType != 'similar-candidate-resume-upload' && !criteriaCount && calledfromData != 'pipeline-list') {
  <div>
    <p class="f-12 line-height-1" [innerHtml]="formatAISummary(candidate?.longSummary)"></p>
  </div>
}
@if(showLongSummaryLoader) {
  <app-hire-skeleton-loaders [showLongSummaryLoader]="showLongSummaryLoader"></app-hire-skeleton-loaders>
}

  <!-- table view -->
  @if (viewMode === 'table' && (criteriaCount > 0 || calledfromData === 'Project' || calledfromData === 'project-upload-candidates' || calledfromData === 'project-inbound-applications' || (calledfromData === 'pipeline-list' && (showExplanationLoader || roleFitTableData?.length > 0))) && !similarityInsightsData) {



  @if(showExplanationLoader) {
  <app-hire-skeleton-loaders [showExplanationLoader]="showExplanationLoader"></app-hire-skeleton-loaders>
  } @else{
  <div class="table-view mb-3">
    <div class="table-header-row">
      <div class="table-header-col">
        <span class="mr-1">
          Hiring Criteria
        </span>
        <!-- <span>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M7 1.49976H10.5V4.99976" stroke="#5E5E5E" stroke-width="1.03239" stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M10.5 7.36818V9.74976C10.5 10.164 10.1642 10.4998 9.75 10.4998H2.25C1.83579 10.4998 1.5 10.164 1.5 9.74976V2.24976C1.5 1.83554 1.83579 1.49976 2.25 1.49976H4.5"
              stroke="#5E5E5E" stroke-width="1.03239" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6.44971 5.55034L10.2747 1.72534" stroke="#5E5E5E" stroke-width="1.03239" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span> -->
      </div>
      <div class="table-header-col">
        AI Reasoning
      </div>
    </div>
    <!-- table view row -->
    @for(data of roleFitTableData; track data.id){
    <div class="table-body-row">
      <div class="table-body-col">
        <span class="mb-0" [matTooltip]="getTitlecase(data.content || data.criteria)" matTooltipPosition="above" [matTooltipClass]="{ 'red-tooltip': true }">
          <span class="mr-1" [innerHTML]="data.icon"></span>
          <span>{{ data.criteria | titlecase }}</span>
        </span>
      </div>
      <div class="table-body-col">{{ data.reasoning ?? data.criteria_content }}</div>
    </div>
    }
  </div>
  }
  }
  <!-- detailed view -->
  @if (viewMode === 'detail' && (criteriaCount > 0 || calledfromData === 'Project' || (calledfromData === 'pipeline-list' && (showExplanationLoader || roleFitTableData?.length > 0)))) {
  @for(data of roleFitTableData; track data.id){
  <div class="d-flex align-items-start justify-content-start mb-2">
    <div class="mr-1" [innerHTML]="data.icon"></div>
    <div>
      <p class="f-12 font-weight-500 mb-1 d-inline-block common-chip-label" [matTooltip]="data.content || data.criteria" matTooltipPosition="above" [matTooltipClass]="{ 'red-tooltip': true }">{{ data.criteria }}</p>
      <p class="mb-0 font-weight-400 f-12">{{ data.details }}</p>
    </div>
  </div>
  }
  }

  @if(calledfromData === 'pipeline-list' && candidate?.showInProgressMessage == true)  {
<div class="d-flex align-items-center mb-3">
  <span class="f-12 text-9696">
    We're working on
    <span class="ai-summary mx-1">
      <span class="mr-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none">
          <path d="M1.50809 10.7534C1.5047 10.8992 1.5492 11.0421 1.63475 11.1601C1.71921 11.2805 1.84109 11.3695 1.98142 11.4134L3.12142 11.7934C3.47257 11.9101 3.792 12.1063 4.05475 12.3668C4.31721 12.628 4.51374 12.9479 4.62809 13.3001L5.02809 14.4334C5.06975 14.5695 5.15385 14.6886 5.26809 14.7734C5.39001 14.8562 5.53404 14.9004 5.68142 14.9001C5.82932 14.9064 5.97512 14.8633 6.09583 14.7776C6.21654 14.6919 6.30529 14.5685 6.34809 14.4268L6.72809 13.2868C6.84243 12.9346 7.03896 12.6147 7.30142 12.3534C7.56635 12.0942 7.88495 11.8962 8.23475 11.7734L9.37475 11.4001C9.50971 11.3528 9.6279 11.2671 9.71475 11.1534C9.80228 11.0331 9.85111 10.8889 9.85475 10.7401C9.86107 10.5922 9.81799 10.4464 9.73228 10.3257C9.64658 10.205 9.52314 10.1162 9.38142 10.0734L8.23475 9.69344C7.87914 9.57853 7.5559 9.38081 7.29165 9.11655C7.02739 8.85229 6.82966 8.52905 6.71475 8.17344L6.33475 7.04677C6.29589 6.90814 6.2132 6.78582 6.09904 6.6981C5.98487 6.61037 5.84538 6.56196 5.70142 6.56011C5.55809 6.56011 5.41742 6.59944 5.29475 6.67344C5.17342 6.75678 5.08009 6.87544 5.02809 7.01344L4.64142 8.17344C4.52651 8.52905 4.32878 8.85229 4.06453 9.11655C3.80027 9.38081 3.47703 9.57853 3.12142 9.69344L1.98809 10.0934C1.8502 10.1386 1.73083 10.2276 1.64809 10.3468C1.55777 10.4631 1.50854 10.6061 1.50809 10.7534ZM8.17409 6.51344C8.17511 6.64413 8.21452 6.77164 8.28742 6.88011C8.36622 6.98743 8.47535 7.0687 8.60075 7.11344L9.44075 7.39344C9.67609 7.47477 9.88942 7.60678 10.0674 7.78011C10.2414 7.95756 10.3735 8.17167 10.4541 8.40677L10.7408 9.23344C10.7814 9.36099 10.8635 9.47128 10.9741 9.54677C11.0837 9.6233 11.2138 9.66511 11.3474 9.66677C11.4841 9.6645 11.6167 9.62029 11.7274 9.54011C11.8323 9.46035 11.9111 9.35132 11.9541 9.22678L12.2274 8.39344C12.3076 8.16013 12.4398 7.94811 12.6141 7.77344C12.7848 7.59431 12.9981 7.4613 13.2341 7.38678L14.0674 7.10677C14.1967 7.06607 14.3091 6.98411 14.3874 6.87344C14.4405 6.79033 14.4745 6.69648 14.4869 6.59866C14.4993 6.50084 14.4899 6.40148 14.4593 6.30774C14.4286 6.214 14.3776 6.12822 14.3099 6.05658C14.2421 5.98494 14.1593 5.92922 14.0674 5.89344L13.2341 5.62011C12.9983 5.53778 12.7841 5.4033 12.6075 5.22669C12.4309 5.05009 12.2964 4.83591 12.2141 4.60011L11.9408 3.78011C11.9015 3.65722 11.8274 3.54838 11.7274 3.46677C11.6212 3.38676 11.4935 3.34033 11.3608 3.33344C11.2262 3.32983 11.0938 3.36701 10.9808 3.44011C10.8695 3.51518 10.7836 3.62206 10.7341 3.74677L10.4541 4.60011C10.3718 4.83591 10.2373 5.05009 10.0607 5.22669C9.88406 5.4033 9.66988 5.53778 9.43409 5.62011L8.60075 5.90677C8.47612 5.94959 8.36859 6.0314 8.29409 6.14011C8.21518 6.24851 8.17312 6.37936 8.17409 6.51344ZM4.31475 2.94011C4.32079 3.06166 4.35998 3.17924 4.42809 3.28011C4.49746 3.37518 4.59566 3.44532 4.70809 3.48011L5.12142 3.62011C5.20171 3.64782 5.27464 3.69343 5.3347 3.75349C5.39476 3.81355 5.44038 3.88648 5.46809 3.96677L5.61475 4.38677C5.65501 4.48905 5.72174 4.57878 5.80809 4.64677C5.90637 4.72551 6.02882 4.7679 6.15475 4.76677C6.27 4.75962 6.38192 4.72536 6.48142 4.66677C6.58109 4.59335 6.65561 4.49089 6.69475 4.37344L6.83475 3.96011C6.85883 3.87813 6.90495 3.80434 6.96809 3.74677C7.02686 3.6851 7.10023 3.63924 7.18142 3.61344L7.59475 3.48011C7.70474 3.43722 7.80136 3.36591 7.87475 3.27344C7.94392 3.17352 7.98111 3.05496 7.98142 2.93344C7.97755 2.81149 7.93816 2.69333 7.86809 2.59344C7.79628 2.50087 7.69894 2.43134 7.58809 2.39344L7.18142 2.26011C7.09931 2.23209 7.02425 2.1866 6.96142 2.12677C6.90159 2.06394 6.8561 1.98889 6.82809 1.90677L6.68809 1.49344C6.64809 1.39011 6.58475 1.29877 6.50142 1.22677C6.40577 1.15618 6.29299 1.11245 6.17475 1.10011C6.04894 1.09939 5.92582 1.13656 5.82142 1.20677C5.72744 1.27747 5.65384 1.37178 5.60809 1.48011L5.46809 1.90677C5.44007 1.98889 5.39458 2.06394 5.33475 2.12677C5.27275 2.18436 5.20035 2.22961 5.12142 2.26011L4.70142 2.40011C4.59461 2.44213 4.50046 2.51102 4.42809 2.60011C4.35536 2.69863 4.31569 2.81765 4.31475 2.94011Z" fill="url(#paint0_linear_slider_ai)"/>
          <defs>
            <linearGradient id="paint0_linear_slider_ai" x1="3.56375" y1="1.1001" x2="8.58454" y2="1.31613" gradientUnits="userSpaceOnUse">
              <stop stop-color="#C845AB"/>
              <stop offset="1" stop-color="#E24E7F"/>
            </linearGradient>
          </defs>
        </svg>
      </span>
      <span class="font-weight-600">AI Summary</span>
    </span>
    for this candidate. Check back in a little while to see them.
  </span>
</div>
}


@if(searchType == 'job-description' || calledfromData === 'Project') {
  @if(showJDFitInsightsLoader) {
    <app-hire-skeleton-loaders [showJDFitLoader]="showJDFitInsightsLoader"></app-hire-skeleton-loaders>
  } @else {
    @if(jdFitInsightsData.length > 0) {
      <p class="f-12 font-weight-500 mb-2 text-black">JD Fit Insights</p>
  <div class="table-view table-view-3-column">
    <div class="table-header-row">
      <div class="table-header-col">
        <span class="mr-1">
         Criteria
        </span>

      </div>
      <div class="table-header-col">
        Job Requirement
      </div>
        <div class="table-header-col">
        Candidate Qualification
      </div>
    </div>

    <!-- table view row -->
    @for(data of jdFitInsightsData; track data.id){
    <div class="table-body-row">
      <div class="table-body-col">
        <span class="mb-0" >
          <span class="mr-1" [innerHTML]="data.icon"></span>
          <span>{{ data.criteria }}</span>
        </span>
      </div>
      <div class="table-body-col">{{ data.reasoning }}</div>
      <div class="table-body-col">{{ data.qualification }}</div>
    </div>
    }
  </div>
  }
  }

}

@if(searchType == 'similar-candidate-from-linkedinurl' || searchType == 'similar-candidate-resume-upload' || similarityInsightsData) {
  @if(showSimilarityInsightsLoader) {
    <app-hire-skeleton-loaders [showJDFitLoader]="showSimilarityInsightsLoader"></app-hire-skeleton-loaders>
  } @else {
  <div class="table-view">
    <div class="table-header-row">
      <div class="table-header-col">
        <span class="mr-1">
         Criteria
        </span>

      </div>
      <div class="table-header-col">
        Ideal Candidate
      </div>
        <div class="table-header-col">
        {{ candidate?.full_name_with_middle_name | titlecase }}
      </div>
    </div>
    <!-- table view row -->
    @for(data of similarityInsightsData; track data.id){
    <div class="table-body-row">
      <div class="table-body-col">
        <span class="mb-0" >
          <span class="mr-1" [innerHTML]="data.icon"></span>
          <span>{{ data.criteria }}</span>
        </span>
      </div>
      <div class="table-body-col">{{ data.reasoning }}</div>
      <div class="table-body-col">{{ data.qualification }}</div>
    </div>
    }
  </div>
  }

}
  <div>
    <p class="f-10 font-weight-400 text-9696">Disclaimer: These recommendations are indicative and should be used as a
      guide, not as the sole basis for decision-making.</p>
  </div>
</div>
